import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'child-cell-view',
  template: `
      <div class="flex align-items-center list-user-action">
          <a class="" href="javascript:void(0)" title="View" (click)="invokeParentViewMethod()">
          <span *ngIf="!isCheckCircleIcon"><i class="bx bx-show text-warning me-1 font-size-16"></i></span>
          <span *ngIf="isCheckCircleIcon"><i class="bx bx-check-circle text-success font-size-16 ms-2"></i></span>
          </a>
      </div>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})
export class ViewActionsRenderer implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  showUpdate: boolean = false;
  isCheckCircleIcon = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.isCheckCircleIcon = this.params.context.componentName === 'compareRatesComponent';
  }

  public invokeParentViewMethod() {
    this.params.context.componentParent.viewAction(this.params.node.data);
  }

  refresh(): boolean {
    return false;
  }
}
